import { Error } from './components/Error'
import { ErrorBoundary } from './components/ErrorBoundary'
import { Form } from './components/Form'

import { Pending } from './components/Pending'
import { Report } from './components/Report'
import { useAppState } from './hooks/useAppState'

function App() {
  const status = useAppState((s) => s.status)

  return (
    <div className='slqs-widget main'>
      <div className='header'>
        <h1 style={{ marginBottom: 18 }}>
          Improve Your Amazon Listing Quality
        </h1>
        <p className='medium' style={{ padding: '0 30px' }}>
          Get a listing quality report for an existing Amazon listing using
          Spreetail’s proprietary Listing Doctor system. You’ll get a listing
          quality score and 1-2 suggested improvement opportunities.
        </p>
      </div>
      <div className='app'>
        <ErrorBoundary>
          {status === 'intake' && <Form />}
          {status === 'pending' && <Pending />}
          {status === 'error' && <Error />}
          {status === 'complete' && <Report />}
        </ErrorBoundary>
      </div>
    </div>
  )
}

export default App
